<template>
  <div class="filter-date">
    <!--日期选择-->
    <DatePicker
      ref="datePicker"
      :open="datePickerOpen"
      :value="selectedDate"
      :options="datePickerOptions"
      confirm
      type="daterange"
      placement="bottom-end"
      class="filter-datepicker"
      @on-change="DatePickerChange"
      @on-ok="DatePickerOk"
      split-panels
    >
      <a @click="toggleDatePicker" class="filter-datepicker-ctrl">
        <Icon custom="iconfont icon-date"></Icon>
        <span class="filter-content">
          <strong>{{ selectedDate | dateformate }}</strong>
        </span>
        <Icon type="ios-arrow-down"></Icon>
      </a>
    </DatePicker>
  </div>
</template>

<script>
import FilterConst from './FilterConst';
import AnalyticsPublic from '../../base/AnalyticsPublic';

export default {
  name: 'FilterDate',
  components: {},
  data() {
    return {
      // 日历相关配置
      datePickerOptions: {
        shortcuts: FilterConst.datePicker_shortcuts(),
        disabledDate(date) {
          // 控制时间段，当前应用接入 analytics之前的时间段禁选、今天之后的日期禁选
          const registertime = AnalyticsPublic.registertime;
          const appRegistertime = registertime ? registertime.replace(/-/g, '/') : '2011/01/01';
          // eslint-disable-next-line
          return (
            date && (date.valueOf() > Date.now() || date.valueOf() < Date.parse(appRegistertime) - 24 * 3600 * 1000)
          );
        },
      },

      selectedDate: [],
      // 日历显示／隐藏控制
      datePickerOpen: false,
    };
  },
  filters: {
    dateformate(value) {
      return value.join(' ~ ');
    },
  },
  methods: {
    /**
     * 点击日历组件中确定响应事件
     **/
    DatePickerOk() {
      this.datePickerOpen = false;
      this.$emit('gob-change-date', this.selectedDate);

      this.datePickerOptions.disabledDate = date => {
        // 控制时间段，当前应用接入 analytics之前的时间段禁选、今天之后的日期禁选
        const registertime = AnalyticsPublic.registertime;
        const appRegistertime = registertime ? registertime.replace(/-/g, '/') : '2011/01/01';
        // eslint-disable-next-line
        return date && (date.valueOf() > Date.now() || date.valueOf() < Date.parse(appRegistertime) - 24 * 3600 * 1000);
      };
    },
    /**
     * 选择日期改变响应事件
     **/
    DatePickerChange(date) {
      const limitDate = new Date('2018-01-01');
      if (new Date(date[0]) < limitDate) {
        this.datePickerOptions.disabledDate = date1 => {
          const registertime = AnalyticsPublic.registertime;
          const appRegistertime = registertime ? registertime.replace(/-/g, '/') : '2011/01/01';
          // eslint-disable-next-line
          return (
            date1 &&
            (date1.valueOf() > limitDate - 24 * 3600 * 1000 ||
              date1.valueOf() < Date.parse(appRegistertime) - 24 * 3600 * 1000)
          );
        };
        if (new Date(date[1]) >= limitDate) {
          // eslint-disable-next-line
          date[1] = '2017-12-31';
        }
      }
      this.selectedDate = date;
    },
    toggleDatePicker() {
      this.datePickerOpen = !this.datePickerOpen;
    },

    getDay(days) {
      const today = new Date().valueOf();
      const selday = new Date(today + days * 3600 * 1000 * 24);
      const year = selday.getFullYear();
      const month = selday.getMonth() >= 9 ? selday.getMonth() + 1 : `0${selday.getMonth() + 1}`;
      const day = selday.getDate() >= 10 ? selday.getDate() : `0${selday.getDate()}`;
      return `${year}-${month}-${day}`;
    },
  },
  mounted() {
    // 默认时间为最近一个月
    if (AnalyticsPublic.selectedDate.length === 0) {
      AnalyticsPublic.selectedDate = [this.getDay(-30), this.getDay(0)];
    }
    this.selectedDate = AnalyticsPublic.selectedDate;
  },
};
</script>

<style scoped>
.filter-date {
  height: 36px;
  line-height: 36px;
  /* margin-right: 12px; */
  /* vertical-align: top; */
}

.filter-content {
  padding: 0 8px;
}

.filter-content .ivu-btn {
  padding: 0 0 2px 5px;
}

/* ==== */

.filter-datepicker {
  padding: 1px 0;
}

.filter-datepicker .ivu-picker-confirm button:first-child {
  display: none;
}

.filter-datepicker-ctrl {
  color: #657180;
}
</style>
